import React from 'react';

import { useNavigate, useParams } from 'react-router-dom';
import { UiComponent } from 'components';
import { IQuestion } from 'types';
import { EventFeedbackQuery } from 'queries';
import { toast } from 'react-toastify';
import { DEFAULT_ERROR_MESSAGE } from 'data/message';

function Feedback() {
  const navigate = useNavigate();
  const { id } = useParams();

  const { data, isLoading } = EventFeedbackQuery.useGet(id || '');
  const { mutate: create } = EventFeedbackQuery.useCreate();
  const { mutate: update } = EventFeedbackQuery.useUpdate();

  const handleDone = () => {
    toast.success('피드백 저장완료');
    navigate(-1);
  };

  const onCreate = (title: string, questions: IQuestion[]) => {
    if (!id) return;
    const data = { id, title, questions: JSON.stringify(questions) };
    create(data, {
      onSuccess: handleDone,
      onError: () => {
        toast.error(DEFAULT_ERROR_MESSAGE);
      },
    });
  };

  const onUpdate = (title: string, questions: IQuestion[]) => {
    if (!id || !data) return;

    update(
      { id: data.id, title, questions: JSON.stringify(questions) },
      {
        onSuccess: handleDone,
        onError: () => {
          toast.error(DEFAULT_ERROR_MESSAGE);
        },
      },
    );
  };

  const handleSave = (title: string, questions: IQuestion[]) => {
    if (data) onUpdate(title, questions);
    else onCreate(title, questions);
  };

  if (isLoading) return null;

  return (
    <div>
      <UiComponent.Forms
        formData={{ title: data?.title, questions: data?.questions }}
        type={'feedback'}
        onSave={handleSave}
      />
    </div>
  );
}

export default Feedback;
